var _classCallCheck = require("C:\\Users\\Vithuran Sadagopan\\Documents\\blockvote\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\Vithuran Sadagopan\\Documents\\blockvote\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var address = require("./encoding/address");

var encoding = require("./encoding/encoding");

var nacl = require("./nacl/naclWrappers");

var utils = require("./utils/utils");

var base32 = require('hi-base32');

var ALGORAND_TRANSACTION_LENGTH = 52;
var ALGORAND_MIN_TX_FEE = 1000; // version v5

/**
 * Transaction enables construction of Algorand transactions
 * */

var Transaction =
/*#__PURE__*/
function () {
  "use strict";

  function Transaction(_ref) {
    var from = _ref.from,
        to = _ref.to,
        fee = _ref.fee,
        amount = _ref.amount,
        firstRound = _ref.firstRound,
        lastRound = _ref.lastRound,
        note = _ref.note,
        genesisID = _ref.genesisID,
        genesisHash = _ref.genesisHash,
        closeRemainderTo = _ref.closeRemainderTo,
        voteKey = _ref.voteKey,
        selectionKey = _ref.selectionKey,
        voteFirst = _ref.voteFirst,
        voteLast = _ref.voteLast,
        voteKeyDilution = _ref.voteKeyDilution,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? "pay" : _ref$type,
        _ref$flatFee = _ref.flatFee,
        flatFee = _ref$flatFee === void 0 ? false : _ref$flatFee;

    _classCallCheck(this, Transaction);

    this.name = "Transaction";
    this.tag = Buffer.from([84, 88]); // "TX"

    from = address.decode(from);
    if (to !== undefined) to = address.decode(to);
    if (closeRemainderTo !== undefined) closeRemainderTo = address.decode(closeRemainderTo);
    if (genesisHash === undefined) throw Error("genesis hash must be specified and in a base64 string.");
    genesisHash = Buffer.from(genesisHash, 'base64');
    if (amount !== undefined && (!Number.isSafeInteger(amount) || amount < 0)) throw Error("Amount must be a positive number and smaller than 2^53-1");
    if (!Number.isSafeInteger(fee) || fee < 0) throw Error("fee must be a positive number and smaller than 2^53-1");
    if (!Number.isSafeInteger(firstRound) || firstRound < 0) throw Error("firstRound must be a positive number");
    if (!Number.isSafeInteger(lastRound) || lastRound < 0) throw Error("lastRound must be a positive number");

    if (note !== undefined) {
      if (note.constructor !== Uint8Array) throw Error("note must be a Uint8Array.");
    } else {
      note = new Uint8Array(0);
    }

    if (voteKey !== undefined) {
      voteKey = Buffer.from(voteKey, "base64");
    }

    if (selectionKey !== undefined) {
      selectionKey = Buffer.from(selectionKey, "base64");
    }

    Object.assign(this, {
      from: from,
      to: to,
      fee: fee,
      amount: amount,
      firstRound: firstRound,
      lastRound: lastRound,
      note: note,
      genesisHash: genesisHash,
      genesisID: genesisID,
      closeRemainderTo: closeRemainderTo,
      voteKey: voteKey,
      selectionKey: selectionKey,
      voteFirst: voteFirst,
      voteLast: voteLast,
      voteKeyDilution: voteKeyDilution,
      type: type
    }); // Modify Fee

    if (!flatFee) {
      this.fee *= this.estimateSize();
    } // If suggested fee too small and will be rejected, set to min tx fee


    if (this.fee < ALGORAND_MIN_TX_FEE) {
      this.fee = ALGORAND_MIN_TX_FEE;
    }
  }

  _createClass(Transaction, [{
    key: "get_obj_for_encoding",
    value: function get_obj_for_encoding() {
      if (this.type == "pay") {
        var txn = {
          "amt": this.amount,
          "fee": this.fee,
          "fv": this.firstRound,
          "lv": this.lastRound,
          "note": Buffer.from(this.note),
          "rcv": Buffer.from(this.to.publicKey),
          "snd": Buffer.from(this.from.publicKey),
          "type": "pay",
          "gen": this.genesisID,
          "gh": this.genesisHash
        }; // parse close address

        if (this.closeRemainderTo !== undefined) txn.close = Buffer.from(this.closeRemainderTo.publicKey); // allowed zero values

        if (!txn.note.length) delete txn.note;
        if (!txn.amt) delete txn.amt;
        if (!txn.fee) delete txn.fee;
        if (!txn.gen) delete txn.gen;
        return txn;
      } else if (this.type == "keyreg") {
        var _txn = {
          "fee": this.fee,
          "fv": this.firstRound,
          "lv": this.lastRound,
          "note": Buffer.from(this.note),
          "snd": Buffer.from(this.from.publicKey),
          "type": this.type,
          "gen": this.genesisID,
          "gh": this.genesisHash,
          "votekey": this.voteKey,
          "selkey": this.selectionKey,
          "votefst": this.voteFirst,
          "votelst": this.voteLast,
          "votekd": this.voteKeyDilution
        }; // allowed zero values

        if (!_txn.note.length) delete _txn.note;
        if (!_txn.fee) delete _txn.fee;
        if (!_txn.gen) delete _txn.gen;
        return _txn;
      }
    }
  }, {
    key: "estimateSize",
    value: function estimateSize() {
      // Generate random key
      var key = nacl.keyPair();
      return this.signTxn(key.secretKey).length;
    }
  }, {
    key: "bytesToSign",
    value: function bytesToSign() {
      var encodedMsg = this.toByte();
      return Buffer.from(utils.concatArrays(this.tag, encodedMsg));
    }
  }, {
    key: "toByte",
    value: function toByte() {
      return encoding.encode(this.get_obj_for_encoding());
    } // returns the raw signature

  }, {
    key: "rawSignTxn",
    value: function rawSignTxn(sk) {
      var toBeSigned = this.bytesToSign();
      var sig = nacl.sign(toBeSigned, sk);
      return Buffer.from(sig);
    }
  }, {
    key: "signTxn",
    value: function signTxn(sk) {
      // construct signed message
      var sTxn = {
        "sig": this.rawSignTxn(sk),
        "txn": this.get_obj_for_encoding()
      };
      return new Uint8Array(encoding.encode(sTxn));
    }
  }, {
    key: "txID",
    value: function txID() {
      var en_msg = encoding.encode(this.get_obj_for_encoding());
      var gh = Buffer.from(utils.concatArrays(this.tag, en_msg));
      return base32.encode(nacl.genericHash(gh)).slice(0, ALGORAND_TRANSACTION_LENGTH);
    }
  }], [{
    key: "from_obj_for_encoding",
    value: function from_obj_for_encoding(txnForEnc) {
      var txn = Object.create(this.prototype);
      txn.name = "Transaction";
      txn.tag = Buffer.from([84, 88]); // "TX"

      txn.genesisID = txnForEnc.gen;
      txn.genesisHash = Buffer.from(txnForEnc.gh);
      txn.type = txnForEnc.type;
      txn.fee = txnForEnc.fee;
      txn.firstRound = txnForEnc.fv;
      txn.lastRound = txnForEnc.lv;
      txn.note = new Uint8Array(txnForEnc.note);
      txn.from = address.decode(address.encode(new Uint8Array(txnForEnc.snd)));

      if (txnForEnc.type === "pay") {
        txn.amount = txnForEnc.amt;
        txn.to = address.decode(address.encode(new Uint8Array(txnForEnc.rcv)));
        if (txnForEnc.close !== undefined) txn.closeRemainderTo = address.decode(address.encode(txnForEnc.close));
      } else if (txnForEnc.type === "keyreg") {
        txn.voteKey = Buffer.from(txnForEnc.votekey);
        txn.selectionKey = Buffer.from(txnForEnc.selkey);
        txn.voteKeyDilution = txnForEnc.votekd;
        txn.voteFirst = txnForEnc.votefst;
        txn.voteLast = txnForEnc.votelst;
      }

      return txn;
    }
  }]);

  return Transaction;
}();

module.exports = {
  Transaction: Transaction
};